import {Component, OnInit} from '@angular/core';
import { FormBuilder, Validators, FormGroup} from '@angular/forms';

declare var $;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})

export class HomeComponent implements OnInit {
  contacts = [
    {
    img: 'assets/img/man.jpeg',
    name: 'Dr. Mario Landys',
    email: 'mlandys@finlay.edu.cu',
    event: 'Both'
    },
    {
      img: 'assets/img/woman.jpeg',
      name: 'Dr. Yaneli Herrera',
      email: 'yherrera@finlay.edu.cu',
      issues: 'Scientific issues',
      event: 'Vaccipharma',
    },
    {
      img: 'assets/img/man.jpeg',
      name: 'Dr. Silvio Perea',
      email: 'silvio.perea@gigb.educ.cu',
      event: 'Immunopharmacology',
    },
    {
      img: 'assets/img/woman.jpeg',
      name: 'Dr. Idania Rodeiro',
      email: 'idania.rodeiro@infomed.sld.cu',
      issues: 'Scientific issues',
      event: 'Immunopharmacology',
    },
  ];


  dayVaccipharma = '00';
  hoursVaccipharma = '00';
  minutesVaccipharma = '00';
  secondsVaccipharma = '00';
  dayImmunopharmacology = '00';
  hoursImmunopharmacology = '00';
  minutesImmunopharmacology = '00';
  secondsImmunopharmacology = '00';

  commiteeImmunopharmacology = [
    {
      name: 'Mario Landys Chovel',
      status: 'President Organizing Committee'
    },
    {
      name: 'Idania Rodeiro',
      status: 'President, Scientific Committee'
    },
    {
      name: 'Silvio Perea',
      status: 'Vice-President, Scientific Committee'
    },
    {
      name: 'María Acelia Marrero',
      status: 'President, Sociedad Cubana de Farmacología'
    },
    {
      name: 'Eduardo Martínez',
      status: 'President, BioCubaFarma'
    },
    {
      name: 'Ismary Núñez',
      status: 'BioCubaFarma'
    },
    {
      name: 'Giselle Pentón',
      status: 'Centro de Ingeniería Genética y Biotecnológica'
    },
    {
      name: 'Yilian Martínez',
      status: 'Centro de Ingeniería Genética y Biotecnológica'
    },
    {
      name: 'Odalys Blanco',
      status: 'Centro Nacional de Sanidad Agropecuaria'
    },
    {
      name: 'René Delgado',
      status: 'Instituto de Farmacia y Alimentos'
    },
    {
      name: 'Lizet Gil',
      status: 'Instituto Pedro Kourí'
    },
    {
      name: 'Beatriz Sierra',
      status: 'Instituto Pedro Kourí'
    },
    {
      name: 'Adamelis Avilés',
      status: 'Centro de Inmunología Molecular'
    },
    {
      name: 'Belinda Sánchez',
      status: 'Centro de Inmunología Molecular'
    },
    {
      name: 'Lizzette Fontanet',
      status: 'Centro de Inmunología Molecular'
    },
    {
      name: 'Ernesto Bermúdez',
      status: 'Centro de Inmunología Molecular'
    },
    {
      name: 'Luis Velázquez',
      status: 'Cuban Academy of Sciences'
    },
    {
      name: 'Roberto Rodríguez-Labrada',
      status: 'Centro de Neurociencias de Cuba'
    },
    {
      name: 'Majel Cervantes',
      status: 'Centro de Ingeniería Genética y Biotecnológica'
    },
    {
      name: 'Julián Rodríguez',
      status: 'Centro Nacional Coordinador de Ensayos Clínicos'
    },
    {
      name: 'Diadelis Remírez',
      status: 'Centro Estatal de Medicamentos, Equipos y Dispositivos Médicos'
    }];
  immunopharmacologyTopics = [
    {
      name: 'New advances in Immunopharmacology: COVID-19 emergent treatments, Immunobiology of SARS-COV-2' +
        'and other human pathogenic viruses, cancer and chromic inflammatory diseases, regulation of cancer immune response,' +
        'acute inflammation and pain, OMICS platforms for drug discovery' ,
    },
    {
      name: 'Neuroimmunology, neuroimmunopharmacology and neuroimmunomodulation',
    },
    {
      name: ' Hereditary Ataxias and other Neurodegenerative diseases',
    },
    {
      name: 'Pharmacology of cytochrome P450 and transporters',
    },
    {
      name: 'Peptides and Immunopharmacology tools',
    },

    {
      name: 'Advances in Immunology, Vaccines and Therapy of Infectious Diseases',
    },
    {
      name: 'Cellular death',
    }
  ];

  commiteeVaccipharma = [
  {
    name: 'Mario Landys Chovel',
    status: 'President Organizing Committee'
  },
  {
    name: 'Yaneli Herrera',
    status: 'President Scientific Committee'
  },
  {
    name: 'María Acelia Marrero',
    status: 'President, Sociedad Cubana de Farmacología'
  },
  {
    name: 'Eduardo Martínez',
    status: 'President BioCubaFarma'
  },
  {
    name: 'María Victoria Guzmán',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Ismary Núñez',
    status: 'BioCubaFarma'
  },
  {
    name: 'Dagmar García',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Indira Utria',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Ricardo Pérez',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Sonsire Fernández',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Marisel Martínez',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Alfredo Octavio Torrez',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Lourdez Cruz',
    status: 'Instituto Finlay de Vacunas'
  },
  {
    name: 'Sonia Resik',
    status: 'Instituto Pedro Kourí'
  },
  {
    name: 'Rolando Ochoa',
    status: ''
  },
  {
    name: 'Daniel Cardoso',
    status: ''
  },
  {
    name: 'Reinaldo Acevedo',
    status: ''
  },
  {
    name: ' Santa Deybis Orta',
    status: ''
  },
  {
    name: 'Jorge Castro',
    status: 'Centro de Ingeniería Genética y Biotecnológica'
  },
  {
    name: 'Lizet Aldana',
    status: 'Centro de Ingeniería Genética y Biotecnológica'
  },
  {
    name: 'Diadelis Remírez',
    status: 'Centro Estatal de Medicamentos, Equipos y Dispositivos Médicos'
  },
  {
    name: 'Julián Rodríguez',
    status: 'Centro Nacional Coordinador de Ensayos Clínicos'
  },
  {
    name: 'Adamelis Avilés',
    status: 'Centro de Inmunología Molecular'
  }];
  vaccipharmaTopics = [
    {
      name: 'Covid-19 and other Viral Vaccines',
    },
    {
      name: 'Meningococcal and Gonococcal Vaccines',
    },
    {
      name: 'Pneumococcal Vaccines',
    },
    {
      name: 'Enteric Vaccines',
    },
    {
      name: 'Combined Vaccines',
    },
    {
      name: 'Vaccine Technology and Bioprocesses',
    },
    {
      name: 'Implementation of 3Rs methods in QC of vaccines',
    },
    {
      name: 'Technological Transfers',
    },
    {
      name: 'Regulatory issues',
    }];
  logos = [
    {
      name: 'Sociedad Cubana de Farmacología',
      src: '/assets/img/logos/1.png'
    },
    {
      name: 'Instituto Finlay de Vacunas',
      src: '/assets/img/logos/2.png'
    },
    {
      name: 'BiocubaFarma',
      src: '/assets/img/logos/3.png'
    },
    {
      name: 'CNEURO',
      src: '/assets/img/logos/4.png'
    },

    {
      name: 'CECMED',
      src: '/assets/img/logos/5.png'
    },
    {
      name: 'CIGB',
      src: '/assets/img/logos/11.png'
    },
    {
      name: 'PHAR',
      src: '/assets/img/logos/6.png'
    },
    {
      name: 'CIM',
      src: '/assets/img/logos/8.png'
    },
    {
      name: 'BIOZEEN',
      src: '/assets/img/logos/19.png'
    },
    {
      name: 'COMEI',
      src: '/assets/img/logos/12.png'
    },
    {
      name: 'DAKSATA',
      src: '/assets/img/logos/13.png'
    },
    {
      name: 'HISTOKI',
      src: '/assets/img/logos/14.png'
    },
    {
      name: 'IPK',
      src: '/assets/img/logos/7.png'
    },
    {
      name: 'NCI',
      src: '/assets/img/logos/15.png'
    },
    {
      name: 'PANDA',
      src: '/assets/img/logos/16.png'
    },
    {
      name: 'SHIMADZU',
      src: '/assets/img/logos/17.png'
    },
    {
      name: 'DANYEL BIOTECH',
      src: '/assets/img/logos/18.png'
    },

  ];
  callAbstracts = [
    {
      topic: 'The Organizers will publish the full Scientific Program via Website with Keynote Lectures' +
              'from well-known invited speakers and Oral Presentations chosen from submitted abstracts.',
    },
    {
      topic: 'Oral and Poster presentations should be clearly indicated.',
    },
    {
      topic: 'The Organizing Committee will have the right of choosing oral presentations.',
    },
    {
      topic: 'English is the Congress official language. Translation services will be not available.',
    },
    {
      topic: 'The Organizing Committee of IMMUNOPHARMACOLOGY - VACCIPHARMA 2023 will inform authors  via  E-mail' +
              'about  the  acceptance  of abstracts  not  later  than  one  month  after  the deadline.',
    },
    {
      topic: 'Abstracts Submission Deadline: April 30th, 2023.',
    },
    {
      topic: 'Foreign delegates must send their abstracts by E-mail to: Dr. Mario Landys Chovel Cuervo, ' +
              'E-mail: mlandys@finlay.edu.cu and or mlchovel@gmail.com',
    },
    {
      topic: 'Cuban abstracts for the Congress IMMUNOPHARMACOLOGY 2023 must be sent by E-mail to: immunopharmacology2023@ cigb.edu.cu'
    },
    {
      topic: 'Cuban abstracts for the Congress VACCIPHARMA 2023 must be sent by E-mail to:  vaccipharma@finlay.edu.cu'
    },
    {
      topic: 'Full Instructions to Write Abstracts: Authors should provide their abstract in Word format (Single space). Title: In Black' +
            'and capital letter, Arial 12; Abstract text in Arial 10. Authors: Last name and first letter of the name of each author, using ' +
            'comas among authors (in black, Arial 10). The name of the author who will present the work should be underlined e.g. Rodeiro I, ' +
            'Menendez R, Remirez D. Affiliation: Indicate Institution, Addresses and E-mail of each author below the names and before the ' +
            'abstract  text. Abstracts texts should be clear and precise.  They should contain a brief introduction, materials and methods used,' +
            'the results achieved in research and conclusions. 300 words maximum. Abstracts not following the structure above described will be' +
            'automatically rejected.',
    },
    {
      topic: 'When sending the abstract, please, indicate the Congress (IMMUNOPHARMACOLOGY  or VACCIPHARMA), the Workshop / Symposium and the ' +
              'Topic in which you would like to be included. Each author will have the opportunity to send just one abstract to each Congress.',
    },
    {
      topic: 'The Congress program will be also printed and distributed on site.',
    }];


  constructor(){}

  ngOnInit(): void {
    this.counterDownVaccipharme();
    this.counterDownImmunopharmacology();

  }/*End OnInit*/

  counterDownVaccipharme(){
    const contDowDate = new Date('May 4, 2023 24:00:00').getTime();
    const x = setInterval(() => {
      const now = new Date().getTime();
      const distance = contDowDate - now;
      this.dayVaccipharma = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
      this.hoursVaccipharma = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
      this.minutesVaccipharma = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
      this.secondsVaccipharma = Math.floor((distance % (1000 * 60)) / 1000).toString();

      if (distance < 0 ){
        this.dayVaccipharma = '00';
        this.hoursVaccipharma = '00';
        this.minutesVaccipharma = '00';
        this.secondsVaccipharma = '00';
      }
    }, 1000);
  }

  counterDownImmunopharmacology(){
    const contDowDate = new Date('May 4, 2023 24:00:00').getTime();
    const x = setInterval(() => {
      const now = new Date().getTime();
      const distance = contDowDate - now;

      this.dayImmunopharmacology = Math.floor(distance / (1000 * 60 * 60 * 24)).toString();
      this.hoursImmunopharmacology = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
      this.minutesImmunopharmacology = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
      this.secondsImmunopharmacology = Math.floor((distance % (1000 * 60)) / 1000).toString();

      if (distance < 0 ){
        this.dayImmunopharmacology = '00';
        this.hoursImmunopharmacology = '00';
        this.minutesImmunopharmacology = '00';
        this.secondsImmunopharmacology = '00';
      }
    }, 1000);
  }



}
